import React from 'react';
import {BrowserRouter} from 'react-router-dom';
import {
    ApolloProvider,
    ApolloClient,
    HttpLink,
    InMemoryCache,
} from '@apollo/client';
import {Provider} from 'react-redux';
import App from './App';
import {createStore} from '../../store';

// Create apollo client (graphql)
const client = new ApolloClient({
    // Please note, there is a `apollo-link-batch-http` lib that can batch requests.
    // That doesn't solve issues where a child component is rendered after data comes
    // back from a parent component, however.
    link: new HttpLink({
        credentials: 'same-origin',
        headers: {
            'x-csrf-jwt': window.ha.csrfToken,
        },
    }),
    // Initialize with server side rendered data that was embedded in the page
    cache: new InMemoryCache().restore(window.__APOLLO_STATE__),
});

const store = createStore(window.__INITIAL_STATE__);

export const ClientApp: React.FC = () => (
    <ApolloProvider client={client}>
        <Provider store={store}>
            <BrowserRouter>
                <App intl={window.__INTL__} />
            </BrowserRouter>
        </Provider>
    </ApolloProvider>
);
